var imagesLoaded = require('imagesloaded');
var MobileDetect = require('mobile-detect');

var md = new MobileDetect(window.navigator.userAgent);
var classes = [];
var isMobile = (md.mobile() === 'undefined' || md.mobile() === null) ? false : true;
if (isMobile) {
  classes.push('mobile');
}
if (md.os() === 'iOS') {
  classes.push('ios');
} else if (md.os() === 'AndroidOS') {
  classes.push('android');
}
if (md.is('Chrome')) {
  classes.push('chrome');
}
if (md.is('Safari')) {
  classes.push('safari');
}

document.body.classList.add(...classes);

import siteInit from './home';
import { AdobeAn } from './intro';

(function($) {
  // console.log('version 2')

  $(window).on('beforeunload', function() { $(window).scrollTop(0); });

  var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

  var siteLoaded = false;
  var replayCount = 1;
  var minLoops = 1;
  var loaderInstance = imagesLoaded(document.body, { background: true });

  function init() {
    canvas = document.getElementById('intro_canvas');
    anim_container = document.getElementById('animation_container');
    dom_overlay_container = document.getElementById('dom_overlay_container');
    var comp = AdobeAn.getComposition('D3BF8FFD1A924633B375DE9F0FCF18B6');
    AdobeAn.setFillColor('#ffffff')
    // var lib=comp.getLibrary();
    handleComplete({}, comp);
  }

  function handleComplete(evt, comp) {
    //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
    var lib = comp.getLibrary();
    // var ss=comp.getSpriteSheet();
    // exportRoot = new lib.iEVlogoanimationmasthead();
    exportRoot = new lib.iEVlogoanimation1a();

    stage = new lib.Stage(canvas);
    //Registers the 'tick' event listener.
    fnStartAnimation = function() {
      stage.addChild(exportRoot);
      createjs.Ticker.framerate = lib.properties.fps;
      createjs.Ticker.addEventListener('tick', stage);
    }
    //Code to support hidpi screens and responsive scaling.
    AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container], stage);
    AdobeAn.compositionLoaded(lib.properties.id);
    AdobeAn.setAnimationEndHandler(handleAnimationEnd);
    fnStartAnimation();
  }

  function handleAnimationEnd(timeline) {
    replayCount++;
    if (replayCount > minLoops && siteLoaded === true) {
      timeline.stop()
      jQuery('#loader').fadeOut(100, siteInit())
      // siteInit()
    }
  }

  init();
  // siteInit()

  loaderInstance.on('always', function() {
    // console.log('LOADED')
    siteLoaded = true
  });

  /**
   * loader progress
   */
  // loaderInstance.on( 'progress', function( instance, image ) {
  //   var result = image.isLoaded ? 'loaded' : 'broken';
  //   console.log( 'image is ' + result + ' for ' + image.img.src, 'of', loaderInstance.images.length );
  // });


})(jQuery);
